/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useCallback, useRef } from 'react';
import { DataGridPro, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';
import apiAdmin from '../../services/api-admin';
import { MdEdit, MdDelete, MdAdd, MdBlock, MdCalendarMonth, MdCheckCircle } from 'react-icons/md';
import { useForm, Controller } from "react-hook-form";
import { FilePath, validateCoordinates } from '../../services/utilities';
import LinkExternal from '../layout/link-external';
import { TextField, MenuItem, ToggleButtonGroup, ToggleButton, Autocomplete, createFilterOptions, Paper } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedDiv from '../layout/OutlinedDiv';
import "dropzone/dist/dropzone.css";
import { Dropzone } from "dropzone";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DateTime } from 'luxon';
import './foreclosure-sales.scss';
import ForeclosureSaleActivities from './foreclosure-sale-activities';
import CustomDataGridToolbar from '../layout/custom-toolbar';
import { useOktaAuth } from '@okta/okta-react';
import { bootstrap } from '../../app';

const ForeclosureSales = (props) => {
    const { authState } = useOktaAuth();
    const { register, handleSubmit, watch, setValue, getValues, reset, formState: { errors }, control } = useForm({
        defaultValues: {
            currentStatus: 'Active',
            address: '',
            city: '',
            state: '',
            zip: '',
            latitude: null,
            longitude: null,
            latlong: '',
            propertyPhotoSource: null,
            propertyPhoto: null,
            foreclosureSaleLocation: null
        }
    });
    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm();
    const { register: register3, handleSubmit: handleActivitySubmit, getValues: getActivityFormValues, reset: resetActivityForm, control: control3, formState: { errors: errors3 } } = useForm();

    const [foreclosureSales, setForeclosureSales] = useState([]);
    const [foreclosureSaleIdToEdit, setForeclosureSaleIdToEdit] = useState(null);
    const [foreclosureSaleToEdit, setForeclosureSaleToEdit] = useState(null);
    const [foreclosureSaleIdToDelete, setForeclosureSaleIdToDelete] = useState(null);
    const [foreclosureSaleIdToCancel, setForeclosureSaleIdToCancel] = useState(null);
    const [foreclosureSaleIdToAddActivityTo, setForeclosureSaleIdToAddActivityTo] = useState(null);
    const [foreclosureSaleActivityTypeToAdd, setForeclosureSaleActivityTypeToAdd] = useState(null);
    const [propertyPhotoLoading, setPropertyPhotoLoading] = useState(false);
    const [propertyPhotoUrl, setPropertyPhotoUrl] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [expandedRowIds, setExpandedRowIds] = useState(new Set());
    const [activityDeleted, setActivityDeleted] = useState(false);
    const [foreclosureSaleActivityIdToDelete, setForeclosureSaleActivityIdToDelete] = useState(null);
    const [submittingNewSaleLocation, setSubmittingNewSaleLocation] = useState(false);

    const [error, setError] = useState(null);
    const [locations, setLocations] = useState([]);
    const [counties, setCounties] = useState([]);
    const [saleType, setSaleType] = useState('Residential');
    const dzRef = useRef(null);
    const dzInstanceRef = useRef(null);
    const addActivityModal = useRef(null);

    const watchPropertyPhotoSource = watch("propertyPhotoSource");
    const watchPropertyPhoto = watch("propertyPhoto");
    const watchLatLong = watch("latlong");
    const watchAddress = watch("address");
    const watchCity = watch("city");
    const watchState = watch("state");
    const watchZip = watch("zip");

    const apiRef = useGridApiRef();

    const filter = createFilterOptions();
    const addressSorter = (v1, v2) => (v1.address > v2.address ? 1 : -1);
    const locationSorter = (v1, v2) => (v1.companyName > v2.companyName ? 1 : -1);

    const columns = [
        { field: 'status', headerName: 'Status', flex: 100 },
        { field: 'tsNumber', headerName: 'Trustee Sale Number', flex: 200 },

        { field: 'addressObject', headerName: 'Address', flex: 275, sortComparator: addressSorter, renderCell: function (t) { if (!t.value) return <></>; return <p>{t.value.address}<br /><small>{t.value.city}, {t.value.state} {t.value.zip}<br />County: {t.value.county}</small></p> } },
        { field: 'foreclosureSaleLocation', headerName: 'Sale Location', sortComparator: locationSorter, flex: 250, renderCell: function (t) { if (!t.value) return <></>; return <p>{t.value.companyName}<br /><small>{t.value.address}<br />{t.value.city}, {t.value.state} {t.value.zip}</small></p> } },

        { field: 'currentSaleDate', headerName: 'Current Sale Date', flex: 200, renderCell: function (t) { if (!t.value) return <></>; return t.value.toLocaleString("en-US").replace(':00 ', ' ') } },
        { field: 'openingBid', headerName: 'Opening Bid', flex: 200 },

        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            flex: 225,
            cellClassName: 'actions',
            align: 'left',
            getActions: (props) => {
                var actions = [];
                actions.push(
                    <GridActionsCellItem
                        icon={<MdEdit title="Edit" />}
                        label="Edit"
                        onClick={() => { setForeclosureSaleIdToEdit(props.id) }}
                        color="inherit"
                    />);
                actions.push(
                    <GridActionsCellItem
                        icon={<MdDelete title="Delete" />}
                        label="Delete"
                        onClick={() => { setForeclosureSaleIdToDelete(props.id); setDeleted(false) }}
                        color="inherit"
                        data-bs-toggle="modal"
                        data-bs-target="#deleteModal" role="button"
                    />);
                if (props.row.status === "Active") {
                    actions.push(<GridActionsCellItem
                        icon={<MdBlock title="Quick Cancel" />}
                        label="Quick Cancel"
                        onClick={() => { setForeclosureSaleIdToCancel(props.id) }}
                        color="inherit"
                    />);
                    actions.push(<GridActionsCellItem
                        icon={<MdCalendarMonth title="Postpone" />}
                        label="Postpone"
                        onClick={() => {
                            setForeclosureSaleActivityTypeToAdd("Postpone"); setForeclosureSaleIdToAddActivityTo(props.id);
                            var modal = new bootstrap.Modal(addActivityModal.current, {});
                            modal.show();
                        }}
                        color="inherit"
                    />);
                    actions.push(<GridActionsCellItem
                        icon={<MdCheckCircle title="Complete" />}
                        label="Complete"
                        onClick={() => {
                            setForeclosureSaleActivityTypeToAdd("Complete"); setForeclosureSaleIdToAddActivityTo(props.id);
                            var modal = new bootstrap.Modal(addActivityModal.current, {});
                            modal.show();
                        }}
                        color="inherit"
                    />);
                }
                return actions;
            }
        }
    ];

    useEffect(() => {
        const getForeclosureSales = async () => {
            apiAdmin.get(`/foreclosure-sales`)
                .then((response) => {
                    setForeclosureSales(response.data.map((a) => ({ id: a.foreclosureSaleId, tsNumber: a.tsNumber, foreclosureSaleActivities: a.foreclosureSaleActivities, status: a.currentStatus, addressObject: { address: a.address, city: a.city, state: a.state, zip: a.zip, county: a.county }, foreclosureSaleLocation: a.foreclosureSaleLocation, currentSaleDate: new Date(a.currentSaleDate), openingBid: a.openingBid })));
                });
        }

        getForeclosureSales();

        const getCounties = async () => {
            apiAdmin.get(`/foreclosure-sale-counties`)
                .then((response) => {
                    setCounties(response.data);
                });
        }
        getCounties();
        getLocations();

    }, []);

    const getLocations = async () => {
        apiAdmin.get(`/foreclosure-sale-locations`)
            .then((response) => {
                setLocations(response.data);
            });
    }

    useEffect(() => {
        if (!foreclosureSaleIdToEdit || foreclosureSaleIdToEdit === -1) return;
        const getForeclosureSale = async () => {
            apiAdmin.get(`/foreclosure-sale?foreclosureSaleId=${foreclosureSaleIdToEdit}`)
                .then((response) => {
                    setForeclosureSaleToEdit(response.data);
                    Object.keys(response.data).forEach(function (key, index) {
                        if (key.includes('Date')) {
                            setValue(key, DateTime.fromISO(response.data[key]));
                        } else {
                            setValue(key, response.data[key]);
                        }

                    });
                    setValue("latlong", `${response.data.latitude}, ${response.data.longitude}`);
                    setValue("foreclosureSaleLocation", locations.find(f => f.foreclosureSaleLocationId === response.data.foreclosureSaleLocationId));
                    setSaleType(response.data.resCom);
                });
        }
        getForeclosureSale();
    }, [foreclosureSaleIdToEdit]);

    useEffect(() => {
        if (!watchLatLong) return;
        const parts = watchLatLong.split(',').map((part) => part.trim());

        if (parts.length !== 2) return;

        const [latStr, lngStr] = parts;

        // 4. Parse the parts as numbers
        const lat = parseFloat(latStr);
        const lng = parseFloat(lngStr);

        if (isFinite(lat) && isFinite(lng)) {
            setValue("latitude", lat);
            setValue("longitude", lng);
        }
    }, [watchLatLong]);

    useEffect(() => {
        if (!foreclosureSaleIdToCancel) return;

        const foreclosureSaleActivityObject = {
            activityType: 'Cancel',
            note: 'Cancelled',
            foreclosureSaleId: foreclosureSaleIdToCancel
        }
        const addCancellationActivity = async () => {
            await apiAdmin.post(`/save-foreclosure-sale-activity`, foreclosureSaleActivityObject)
                .then((response) => {
                    var updatedRow = [response.data].map((a) => ({ id: a.foreclosureSaleId, tsNumber: a.tsNumber, foreclosureSaleActivities: a.foreclosureSaleActivities, status: a.currentStatus, addressObject: { address: a.address, city: a.city, state: a.state, zip: a.zip, county: a.county }, foreclosureSaleLocation: a.foreclosureSaleLocation, currentSaleDate: new Date(a.currentSaleDate), openingBid: a.openingBid }))
                    apiRef.current.updateRows(updatedRow);
                });
        }
        addCancellationActivity();

    }, [foreclosureSaleIdToCancel]);

    const setupDropZone = () => {
        if (watchPropertyPhotoSource === "custom" && dzRef.current && !dzInstanceRef.current && watchPropertyPhoto === null) {
            Dropzone.autoDiscover = false;
            dzInstanceRef.current = new Dropzone(dzRef.current, {
                url: process.env.REACT_APP_API_ADMIN_BASE_URL + `/foreclosure-sales/upload-custom-photo/${foreclosureSaleIdToEdit}`,
                headers: { 'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_ADMIN_SUBSCRIPTION_KEY, 'Authorization': `Bearer ${authState?.accessToken?.accessToken}` },
                acceptedFiles: '.jpg,.jpeg,.png,.webp',
                maxFilesize: .5,
                maxFiles: 1,
                addRemoveLinks: true,
                resizeWidth: null,
                resizeHeight: 180,
                dictDefaultMessage: "Drag photo here, or click to browse for it.",
                success: function (file, response) {
                    setValue("propertyPhoto", response.fileName);
                }
            });
        }
    }

    useEffect(() => {
        if (!watchPropertyPhotoSource) return;

        const getImg = async (reqObj) => apiAdmin.post(`/foreclosure-sale-property-photo`, reqObj)
            .then((response) => {
                if (response.data && response.data !== "") {
                    setPropertyPhotoUrl(response.data.url);
                }
                else {
                    setPropertyPhotoUrl(null);
                    setValue('propertyPhoto', null);
                }
                setPropertyPhotoLoading(false);
            }
            );

        const propPhotoReqObj = {
            foreclosureSaleId: foreclosureSaleIdToEdit, county: getValues("county"), address: getValues("address"), city: getValues("city"), state: getValues("state"), zip: getValues("zip"),
            latitude: getValues("latitude"), longitude: getValues("longitude"), propertyPhotoSource: watchPropertyPhotoSource, propertyPhoto: watchPropertyPhoto
        };

        var getImage = false;
        if (watchPropertyPhotoSource === "placeholder") setPropertyPhotoUrl(FilePath('/images/foreclosure-sales/no-property-photo-available.png'));
        if (watchPropertyPhotoSource === "custom" && watchPropertyPhoto) getImage = true;
        if (watchPropertyPhotoSource === "custom" && !watchPropertyPhoto) setPropertyPhotoUrl(null);
        if (watchPropertyPhotoSource === "google" && ((propPhotoReqObj.latitude && propPhotoReqObj.longitude) || (propPhotoReqObj.address && propPhotoReqObj.city))) getImage = true;
        if (watchPropertyPhotoSource === "county" && propPhotoReqObj.address && propPhotoReqObj.city && propPhotoReqObj.county) getImage = true;
        if (getImage) {
            setPropertyPhotoLoading(true);
            getImg(propPhotoReqObj);
        }
        if (watchPropertyPhotoSource !== "custom" && watchPropertyPhoto) setValue("propertyPhoto", null);

        if (watchPropertyPhotoSource !== "custom" && dzInstanceRef.current) {
            setValue("propertyPhoto", null);
            dzInstanceRef.current.destroy();
            dzInstanceRef.current = null;
        }

        setupDropZone();

    }, [foreclosureSaleIdToEdit, watchPropertyPhotoSource, watchPropertyPhoto]);

    const resetCustomPhotoUpload = () => {
        if (dzInstanceRef.current) {
            dzInstanceRef.current.destroy();
            dzInstanceRef.current = null;
        }
        setValue('propertyPhoto', null);
        setPropertyPhotoUrl(null);
    }

    useEffect(() => {
        if (!watchAddress || !watchCity || !watchState || !watchZip || watchZip.length < 5) return;

        const getCoords = async (reqObj) => apiAdmin.post(`/coordinates-by-address`, reqObj)
            .then((response) => {
                if (response.data && response.data !== "") {
                    setValue("latlong", `${response.data.latitude}, ${response.data.longitude}`, { shouldDirty: true, shouldTouch: true });
                }
            });
        getCoords({ fullAddress: `${watchAddress}, ${watchCity}, ${watchState} ${watchZip}` });

    }, [watchAddress, watchCity, watchState, watchZip]);

    function EditToolbar(props) {
        return (
            <CustomDataGridToolbar>
                <span className="btn-link btn" onClick={() => { setForeclosureSaleIdToEdit(-1) }}>
                    <MdAdd className="mb-1" /> Add Foreclosure Sale
                </span>
            </CustomDataGridToolbar>
        );
    }

    const onSubmit = data => {
        const foreclosureSaleObject = {
            ...data,
            foreclosureSaleId: foreclosureSaleIdToEdit,
            foreclosureSaleLocationId: getValues("foreclosureSaleLocation").foreclosureSaleLocationId,
            resCom: saleType
        }
        const saveForeclosureSale = async () => {
            await apiAdmin.post(`/save-foreclosure-sale`, foreclosureSaleObject)
                .then((response) => {
                    if (response.data) {
                        setForeclosureSaleIdToEdit(null);
                        setForeclosureSaleToEdit(null);
                        setPropertyPhotoUrl(null);
                        setSubmitted(true);
                        setSubmitting(false);
                        reset();
                        var newOrUpdatedRow = { ...response.data, id: response.data.foreclosureSaleId, status: response.data.currentStatus, addressObject: { address: response.data.address, city: response.data.city, state: response.data.state, zip: response.data.zip, county: response.data.county }, foreclosureSaleLocation: locations.find(f => f.foreclosureSaleLocationId === response.data.foreclosureSaleLocationId), currentSaleDate: new Date(response.data.currentSaleDate) };
                        var isUpdate = foreclosureSales.some(s => s.id === newOrUpdatedRow.id);

                        if (isUpdate) {
                            setForeclosureSales(foreclosureSales.map((s, i) => {
                                return (s.id === newOrUpdatedRow.id) ? newOrUpdatedRow : s;
                            }));
                        }
                        else {
                            setForeclosureSales([...foreclosureSales, newOrUpdatedRow]);
                        }

                    } else {
                        setError("There was an error saving the foreclosure sale. Please try again.")
                    }
                });
        }
        setSubmitting(true);
        saveForeclosureSale();
    }

    const deleteForeclosureSale = () => {
        const deleteMessage = async () => {
            await apiAdmin.post(`/delete-foreclosure-sale?foreclosureSaleId=` + foreclosureSaleIdToDelete)
                .then((response) => {
                    if (response.statusText === "OK") {
                        setForeclosureSaleIdToDelete(null);
                        setDeleted(true);
                        setForeclosureSales(foreclosureSales.filter(s => s.id !== foreclosureSaleIdToDelete));

                    } else {
                        setError("There was an error deleting the foreclosure sale. Please try again.")
                    }
                });
        }
        deleteMessage();
    }

    const deleteForeclosureSaleActivity = () => {
        const deleteMessage = async () => {
            await apiAdmin.post(`/delete-foreclosure-sale-activity?foreclosureSaleActivityId=` + foreclosureSaleActivityIdToDelete)
                .then((response) => {
                    if (response.statusText === "OK") {
                        setForeclosureSaleActivityIdToDelete(null);
                        setActivityDeleted(true);
                    } else {
                        setError("There was an error deleting the foreclosure sale activity. Please try again.")
                    }
                });
        }
        deleteMessage();
    }

    const autoFillAddress = () => {
        var fileNumber = getValues('tsNumber');
        if (fileNumber === '') return;
        const autofill = async () => {
            await apiAdmin.get(`/get-address-by-file-number?fileNumber=` + fileNumber)
                .then((response) => {
                    if (!response.data) return;
                    setValue('address', `${response.data.streetNumber} ${response.data.streetDirection ? response.data.streetDirection + ' ' : ''}${response.data.streetName} ${response.data.streetSuffix ? response.data.streetSuffix : ''}`);
                    setValue('city', response.data.city.name);
                    setValue('state', response.data.state);
                    setValue('zip', response.data.zip)
                    setValue("propertyPhotoSource", "county");
                });
        }
        autofill();
    }
    function DetailPanelContent({ row: rowProp }) {
        return (
            <Paper className="p-3">
                <ForeclosureSaleActivities foreclosureSaleId={rowProp.id} setForeclosureSaleActivityIdToDelete={setForeclosureSaleActivityIdToDelete} setActivityDeleted={setActivityDeleted} activityDeleted={activityDeleted} />
            </Paper>
        )
    }

    const handleDetailPanelExpandedRowIdsChange = useCallback((newIds) => {
        setExpandedRowIds(newIds.length > 1 ? new Set([newIds[newIds.length - 1]]) : new Set(newIds),);
    }, []);

    const addLocation = data => {
        if (!data) return;
        const add = async () => {
            await apiAdmin.post(`/add-foreclosure-sale-location`, data)
                .then((response) => {
                    setSubmittingNewSaleLocation(false);
                    if (response.data) {
                        reset2();
                        getLocations();
                    } else {
                        setError("There was an error saving the foreclosure sale. Please try again.")
                    }
                });
        }
        setSubmittingNewSaleLocation(true);
        add();
    }

    const addActivity = data => {
        if (!data) return;

        const foreclosureSaleActivityObject = {
            ...data,
            activityType: foreclosureSaleActivityTypeToAdd,
            foreclosureSaleId: foreclosureSaleIdToAddActivityTo
        }
        const addActivityEntry = async () => {
            await apiAdmin.post(`/save-foreclosure-sale-activity`, foreclosureSaleActivityObject)
                .then((response) => {
                    var updatedRow = [response.data].map((a) => ({ id: a.foreclosureSaleId, tsNumber: a.tsNumber, foreclosureSaleActivities: a.foreclosureSaleActivities, status: a.currentStatus, addressObject: { address: a.address, city: a.city, state: a.state, zip: a.zip, county: a.county }, foreclosureSaleLocation: a.foreclosureSaleLocation, currentSaleDate: new Date(a.currentSaleDate), openingBid: a.openingBid }))
                    apiRef.current.updateRows(updatedRow);
                    resetActivityForm();
                    setForeclosureSaleIdToAddActivityTo(null);
                    setForeclosureSaleActivityTypeToAdd(null);
                    var mdl = bootstrap.Modal.getInstance(addActivityModal.current)
                    mdl.hide();
                });
        }
        addActivityEntry();
    }

    const getApplyQuickFilterFnAddress = (value) => {
        if (!value) return null;
        value = value.toLowerCase();
        return (cellValue) => {
            if (!cellValue) return false;
            return cellValue.address?.toLowerCase().split(' ').includes(value) || cellValue.city?.toLowerCase().includes(value) || cellValue.state?.toLowerCase().includes(value) || cellValue.zip?.toLowerCase().includes(value) || cellValue.county?.toLowerCase().includes(value);

        };
    };

    const getApplyQuickFilterFnLocation = (value) => {
        if (!value) return null;
        value = value.toLowerCase();
        return (cellValue) => {
            if (!cellValue) return false;
            return cellValue.address?.toLowerCase().split(' ').includes(value) || cellValue.city?.toLowerCase().includes(value) || cellValue.state?.toLowerCase().includes(value) || cellValue.zip?.toLowerCase().includes(value) || cellValue.companyName?.toLowerCase().includes(value);

        };
    };

    return (
        <div>
            <title>Foreclosure Sales</title>
            <h1>Foreclosure Sales</h1>
            {foreclosureSaleToEdit || foreclosureSaleIdToEdit === -1 ? <>
                <form key={1} onSubmit={handleSubmit(onSubmit)}>
                    <div className="border p-3">
                        <div className="mb-3">
                            <div className="row">
                                <div className="col">
                                    <Controller
                                        name="currentStatus"
                                        control={control}
                                        defaultValue="Active"
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <OutlinedDiv label="Status">
                                                <RadioGroup
                                                    row
                                                    {...field}
                                                >
                                                    <FormControlLabel value="Active" control={<Radio />} label="Active" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem' } }} />
                                                    <FormControlLabel value="Complete" control={<Radio />} label="Complete" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem' } }} />
                                                    <FormControlLabel value="Cancelled" control={<Radio />} label="Cancelled" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem' } }} />
                                                </RadioGroup>
                                            </OutlinedDiv>
                                        )} />
                                </div>
                                <div className="col">
                                    <ToggleButtonGroup
                                        className="float-end"
                                        value={saleType}
                                        exclusive
                                        onChange={(e, newType) => {setSaleType(newType)}}
                                        aria-label="Sale Type"
                                        >
                                        <ToggleButton value="Residential" aria-label="Residential">Residential</ToggleButton>
                                        <ToggleButton value="Commercial" aria-label="Commercial">Commercial</ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        {foreclosureSaleIdToEdit !== -1 && <div className="mb-3">
                            <Controller
                                name="originalSaleDate"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <DateTimePicker disabled value={value} onChange={onChange} className="w-100" label="Original Sale Date/Time" />
                                )}
                            />
                        </div>}
                        <div className="mb-3">
                            <Controller
                                name="currentSaleDate"
                                control={control}
                                rules={{ validate: { dateValid: () => DateTime.fromISO(getValues("currentSaleDate")).isValid }}}
                                render={({ field: { onChange, value } }) => (
                                    <DateTimePicker  value={value} onChange={onChange} className="w-100" label="Sale Date/Time"/>
                                )}
                            />
                            {errors?.currentSaleDate?.type === "dateValid" && <small className="text-danger">This field is required</small>}
                        </div>
                        <div className="mb-3">
                            <Controller
                                name="county"
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        select
                                        label="County *"
                                        className="w-100"
                                        {...field}
                                    >
                                        {counties.map((option) => (
                                            <MenuItem key={"c_" + option.countyId} value={option.countyName}>
                                                {option.countyName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )} />
                            {errors?.county?.type === "required" && <div className="small text-danger">Please make a selection.</div>}
                        </div>
                        <div className="d-flex-column d-lg-flex">
                            <div className="flex-fill me-3">
                                <div className="mb-3">
                                    <div className="row">
                                        <div className="col col-md-6">
                                            <TextField
                                                label="TS Number"
                                                {...register("tsNumber")}
                                                className="w-100"
                                            />
                                        </div>
                                        <div className="col col-md-6">
                                            <button type="button" className="btn btn-primary" onClick={() => autoFillAddress()}>Autofill Address from ResWare</button>
                                        </div>
                                    </div>                            
                                </div>
                                <div className="mb-3">
                                    <Controller
                                        name="address"
                                        control={control}
                                        render={({field})=>(
                                        <TextField
                                            {...field}
                                            label="Property Address"
                                            className="w-100"
                                        />
                                    )} />
                                </div>
                                <div className="row mb-3">
                                    <div className="col-5">
                                        <Controller
                                            name="city"
                                            control={control}
                                            render={({field})=>(
                                            <TextField
                                                {...field}
                                                label="City"
                                                className="w-100"
                                            />
                                        )} />
                                    </div>                                   
                                    <div className="col-3">
                                        <Controller
                                            name="state"
                                            control={control}
                                            rules={{ required: true }}
                                            render={({field})=>(
                                            <TextField
                                                {...field}
                                                label="State *"
                                                className="w-100"
                                                inputProps={{maxLength: 2} }
                                            />
                                        )} />
                                        {errors?.state?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>                                
                                    <div className="col-4">
                                        <Controller
                                            name="zip"
                                            control={control}
                                            rules={{ required: true }}
                                            render={({field})=>(
                                            <TextField
                                                {...field}
                                                label="Zip *"
                                                className="w-100"
                                                inputProps={{maxLength: 5} }
                                            />
                                        )} />
                                        {errors?.zip?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>
                                </div>
                            </div>
                            <div className="flex-fill me-3 pb-3">
                                <OutlinedDiv label="Photo">
                                    {(watchPropertyPhotoSource === "custom" && watchPropertyPhoto !== null &&
                                        !propertyPhotoLoading && propertyPhotoUrl) ?
                                        <div>
                                            <span className="btn-link btn ps-0 py-0" onClick={resetCustomPhotoUpload}>Select a different photo?</span>
                                            <img src={propertyPhotoUrl} alt="Property" height="140" />
                                        </div>
                                        :
                                        <div className="foreclosure-photo-container d-flex justify-content-center align-items-center">
                                            {(watchPropertyPhotoSource === "google" ||
                                                (watchPropertyPhotoSource === "county" && propertyPhotoUrl !== null)
                                            ) && !propertyPhotoLoading && propertyPhotoUrl &&
                                                <img src={propertyPhotoUrl} alt="Property" className="object-fit-scale w-100" />}
                                            {(watchPropertyPhotoSource === "placeholder" || (watchPropertyPhotoSource === "county" && !propertyPhotoUrl && !propertyPhotoLoading)) &&
                                                <img src={FilePath('/images/foreclosure-sales/no-property-photo-available.png')} alt="Not Available" className="w-100 object-fit-scale" />}
                                            {watchPropertyPhotoSource === "custom" && watchPropertyPhoto === null &&
                                                <div><div className="dropzone foreclosure-dropzone dropzone-previews border-primary bg-light" ref={dzRef} /><div className="small">Photo should be less than 500k.</div></div>}
                                        </div>
                                    }
                                </OutlinedDiv>
                                <input type="hidden" {...register("propertyPhoto", { value: null }) } />
                            </div>
                            <div className="flex-fill pb-3">
                                <Controller
                                    name="propertyPhotoSource"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <OutlinedDiv label="Photo Source">
                                            <RadioGroup
                                                {...field}
                                            >
                                                <FormControlLabel value="google" control={<Radio />} label="Google Street View" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem', lineHeight: '0.9375rem' } }} />
                                                <FormControlLabel value="county" control={<Radio />} label="County" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem' } }} />
                                                <FormControlLabel value="custom" control={<Radio />} label="Custom Upload" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem' } }} />
                                                <FormControlLabel value="placeholder" control={<Radio />} label="Placeholder" sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9375rem' } }} />
                                            </RadioGroup>
                                        </OutlinedDiv>
                                    )} />
                                {errors?.propertyPhotoSource?.type === "required" && <div className="small text-danger">Please make a selection.</div>}
                            </div>
                        </div>
                        <div className="mb-3">
                            <Controller
                                name="latlong"
                                control={control}
                                defaultValue=""
                                rules={{ required: true, validate: validateCoordinates } }
                                render={({ field }) => (
                                    <TextField
                                        label="Latitude & Longitude *"
                                        {...field}
                                        className="w-50"
                                        inputProps={{ maxLength: 75}}
                                    />
                                )}
                            />
                            <LinkExternal className="ms-3 mt-3 d-inline-block" href={`https://www.google.com/maps/search/?api=1&query=${watchLatLong}`}>View location on map</LinkExternal>
                            {errors?.latlong && <div className="small text-danger">{errors.latlong.message}</div>}
                            <input type="hidden" {...register("latitude")} />
                            <input type="hidden" {...register("longitude")} />
                        </div>                        
                        <div className="row mb-3">
                            <div className="col-12 col-md-9">
                                <Controller
                                    name="foreclosureSaleLocation"
                                    rules={{ required: true }}
                                    control={control}
                                    render={({ field: {onChange, value, onBlur, ref}, fieldState: {error} }) => (
                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => { return option.foreclosureSaleId === value.foreclosureSaleId }}
                                            onChange={(event, newValue) => onChange(newValue)} // Update react-hook-form's value
                                            value={value || null}
                                            onBlur={onBlur}
                                            ref={ref}
                                            disablePortal
                                            id="sale location"
                                            filterOptions={(options, params) => {
                                                const filtered = filter(options, params);
                                                return filtered;
                                            }}
                                            options={locations}
                                            getOptionLabel={(option) => {
                                                if (typeof option === 'string') {
                                                    return option;
                                                }
                                                return `${option.companyName}, ${option.address} ${option.city}, ${option.state} ${option.zip}`;
                                            }}
                                            renderOption={(props, option) => {
                                                const { key, ...optionProps } = props;
                                                return (
                                                    <li key={key} {...optionProps}>
                                                        {option.companyName}, {option.address} {option.city}, {option.state} {option.zip}
                                                    </li>
                                                );
                                            }}
                                            selectOnFocus
                                            clearOnBlur
                                            handleHomeEndKeys
                                            renderInput={(params) => <TextField {...params} label="Sale Location" />}
                                            />
                                        
                               )}/>
                               {errors?.foreclosureSaleLocation?.type === "required" && <div className="small text-danger">Please make a selection.</div>}
                            </div>
                            <div className="col-12 col-md-3">
                                <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addLocationModal">Add New Location</button>
                            </div>
                        </div>
                        <div className="mb-3">
                            <TextField
                                label="Opening Bid"
                                {...register("openingBid")}
                                className="w-100"
                                inputProps={{maxLength: 100}}
                            />
                        </div>                        
                        <div className="mb-3">
                            <TextField
                                label="Sale Amount"
                                {...register("saleAmount")}
                                className="w-100"
                                type="number"
                                inputProps={{
                                        step: ".01"
                                      }}                            
                                />
                        </div>                        
                        <div className="mb-3">
                            <TextField
                                label="Note"
                                {...register("note")}
                                className="w-100"
                                multiline
                                rows={3}
                            />
                        </div>
                    </div>
                    <div className="pt-2">
                        <button key={1} type="submit" disabled={submitting} className="btn btn-primary me-4">{submitting ? <><span className="spinner-border spinner-border-sm" aria-hidden="true"></span><span role="status"> Saving...</span></> : "Submit"}</button>
                        <button type="button" className="btn btn-primary" onClick={() => { setForeclosureSaleIdToEdit(null); setForeclosureSaleToEdit(null); setSubmitted(false); setError(null); setPropertyPhotoUrl(null); reset(); } }>Cancel</button>
                    </div>
                </form>
            </>
            :
            <>
                {submitted && <><div className="alert alert-success alert-dismissible" role="alert">Foreclosure Sale saved successfully!<button type="button" className="btn-close" onClick={() => setSubmitted(false)} aria-label="Close"></button></div></>}
                {deleted &&  <div className="alert alert-warning alert-dismissible" role="alert">Foreclosure Sale deleted successfully!<button type="button" className="btn-close" onClick={() => setDeleted(false)} aria-label="Close"></button></div>}
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                <DataGridPro
                    rows={foreclosureSales}
                    columns={columns.map((column) => {
                      if (column.field === 'addressObject') {
                        return {
                          ...column,
                          getApplyQuickFilterFn: getApplyQuickFilterFnAddress,
                        };
                      }
                      if (column.field === 'foreclosureSaleLocation') {
                        return {
                          ...column,
                          getApplyQuickFilterFn: getApplyQuickFilterFnLocation,
                        };
                      }
                      return column;
                    })}
                    loading={foreclosureSales.length === 0}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'skeleton',
                            noRowsVariant: 'skeleton',
                        }
                    }}
                    autoHeight
                    rowHeight={100}
                    disableRowSelectionOnClick
                    alignItems="center"
                    slots={{
                        toolbar: EditToolbar,
                    }}
                    initialState={{
                        pagination: {
                          paginationModel: { pageSize: 25, page: 0 },
                        },
                        sorting: { sortModel: [{ field: 'currentSaleDate', sort: 'desc' }] }
                      }}
                    pagination
                    getDetailPanelContent={DetailPanelContent}
                    getDetailPanelHeight={({ row }) => 'auto'}
                    onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}
                    detailPanelExpandedRowIds={expandedRowIds}
                    showToolbar
                    apiRef={apiRef} />
            </>
            }
            <div className="modal shown" tabIndex="-1" id="deleteModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Foreclosure Sale?</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this foreclosure sale?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No, Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteForeclosureSale()}>Yes, Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal shown" tabIndex="-1" id="deleteActivityModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Foreclosure Sale Activity?</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this foreclosure sale activity?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No, Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteForeclosureSaleActivity()}>Yes, Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal shown" tabIndex="-1" id="addActivityModal" ref={addActivityModal} >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form key={3} onSubmit={handleActivitySubmit(addActivity)}>
                            <div className="modal-header">
                                <h5 className="modal-title">{foreclosureSaleActivityTypeToAdd}?</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setForeclosureSaleActivityTypeToAdd(null); setForeclosureSaleIdToAddActivityTo(null); resetActivityForm(); }}></button>
                            </div>
                            <div className="modal-body">
                                {foreclosureSaleActivityTypeToAdd === 'Postpone' && <div className="mb-3">
                                    <Controller
                                        name="saleDate"
                                        control={control3}
                                        rules={{ validate: { dateValid: () => DateTime.fromISO(getActivityFormValues("saleDate")).isValid } }}
                                        render={({ field: { onChange, value } }) => (
                                            <DateTimePicker value={value} onChange={onChange} className="w-100" label="New Sale Date *" />
                                        )}
                                    />
                                    {errors3?.saleDate?.type === "dateValid" && <small className="text-danger">This date field is required</small>}
                                </div>}
                                {foreclosureSaleActivityTypeToAdd === 'Complete' && <div className="mb-3">
                                    <TextField
                                        label="Final Sale Amount"
                                        {...register3("finalSaleAmount")}
                                        className="w-100"
                                        type="number"
                                    />
                                </div>}
                                <div className="mb-3">
                                    <TextField
                                        label="Note"
                                        {...register3("note")}
                                        defaultValue={foreclosureSaleActivityTypeToAdd}
                                        className="w-100"
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { setForeclosureSaleActivityTypeToAdd(null); setForeclosureSaleIdToAddActivityTo(null); resetActivityForm(); }}>Close</button>
                                <button key={3} type="submit" className="btn btn-primary">Add</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal shown" tabIndex="-1" id="addLocationModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form key={2} onSubmit={handleSubmit2(addLocation)}>
                            <div className="modal-header">
                                <h5 className="modal-title">Add Location?</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <p>Fill out the fields below to add a location</p>
                                <div className="row">
                                    <div className="col">
                                        <TextField
                                            label="Company Name *"
                                            inputProps={{ maxLength: 100 }}
                                            {...register2("companyName", { maxLength: 100, required: true })}
                                            className="w-100"
                                        />
                                        {errors2?.companyName?.type === "required" && <small className="text-danger">This field is required</small>}
                                        {errors2?.companyName?.type === "maxLength" && <small className="text-danger">Max length is 100</small>}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        <TextField
                                            label="Address *"
                                            inputProps={{ maxLength: 100 }}
                                            {...register2("address", {required: true})}
                                            className="w-100"
                                        />
                                        {errors2?.address?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-5">
                                        <TextField
                                            label="City *"
                                            inputProps={{ maxLength: 100 }}
                                            {...register2("city", {required: true})}
                                            className="w-100"
                                        />
                                        {errors2?.city?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>                                   
                                    <div className="col-3">
                                        <TextField
                                            label="State *"
                                            inputProps={{ maxLength: 2 }}
                                            {...register2("state", {required: true})}
                                            className="w-100"
                                        />
                                        {errors2?.state?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>                                
                                    <div className="col-4">
                                         <TextField
                                            label="Zip *"
                                            inputProps={{ maxLength: 10 }}
                                            {...register2("zip", { required: true })}
                                            className="w-100"
                                        />
                                        {errors2?.zip?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button key={2} type="submit" className="btn btn-primary">{submittingNewSaleLocation ? <><span className="spinner-border spinner-border-sm" aria-hidden="true"></span><span role="status">Saving...</span></>: "Add"}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForeclosureSales;
